import { ImCheckboxChecked, ImCheckboxUnchecked } from "react-icons/im";

interface VehiclePreparationStatusProps {
  vehiclePreparing: {
    cellphoneSupport?: boolean;
    engineProtection?: boolean;
    paintingProtection?: boolean;
    phoneChargerSupport?: boolean;
    tracker?: boolean;
    trackerValidation?: boolean;
    crlvDocument?: boolean;
    nfDocument?: boolean;
    insuranceStatus?: boolean;
    hasSpareKey?: boolean;
  };
}

const VehiclePreparationStatus: React.FC<VehiclePreparationStatusProps> = ({
  vehiclePreparing,
}) => {
  // Crie um array de propriedades para iterar
  const preparationItems = [
    { key: "paintingProtection", value: vehiclePreparing?.paintingProtection },
    { key: "tracker", value: vehiclePreparing?.tracker },
    { key: "cellphoneSupport", value: vehiclePreparing?.cellphoneSupport },
    {
      key: "phoneChargerSupport",
      value: vehiclePreparing?.phoneChargerSupport,
    },
    { key: "engineProtection", value: vehiclePreparing?.engineProtection },
    { key: "trackerValidation", value: vehiclePreparing?.trackerValidation },
    { key: "crlvDocument", value: vehiclePreparing?.crlvDocument },
    { key: "nfDocument", value: vehiclePreparing?.nfDocument },
    { key: "insuranceStatus", value: vehiclePreparing?.insuranceStatus },
    { key: "hasSpareKey", value: vehiclePreparing?.hasSpareKey },
  ];

  return (
    <div className="flex flex-row gap-1 justify-center items-center">
      {preparationItems.map((item, index) => (
        <div key={item.key}>
          {item.value ? (
            <div
              className={`flex justify-between items-center text-greenPrimary my-2 ${
                index === preparationItems.length - 1 ? "" : "mr-1"
              }`}
            >
              <ImCheckboxChecked />
            </div>
          ) : (
            <div
              className={`flex items-center justify-start text-gray3 my-2 ${
                index === preparationItems.length - 1 ? "" : "mr-1"
              } font-semibold`}
            >
              <ImCheckboxUnchecked />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default VehiclePreparationStatus;
